import type { LabPoint } from './types';

/**
 * How the current reading compares to the one immediately before it (AD-29: `previous[0]` only,
 * never an older visit). Null whenever either side is missing or isn't a number, or the previous
 * value is zero (a percentage change from zero is undefined).
 */
export function trendPct(current: LabPoint | null, previous: LabPoint | null): number | null {
  if (current?.number == null || previous?.number == null || previous.number === 0) return null;
  return Math.round(((current.number - previous.number) / previous.number) * 100);
}

/** The raw direction of the same comparison, independent of `trendPct`'s zero-previous guard. */
export function trendDirection(current: LabPoint | null, previous: LabPoint | null): 'up' | 'down' | 'flat' {
  if (current?.number == null || previous?.number == null) return 'flat';
  if (current.number > previous.number) return 'up';
  if (current.number < previous.number) return 'down';
  return 'flat';
}
